// copied from website/app/shared/Section.ts

import {
  OnlineClassroom,
  SearchFilters,
  Section,
} from "@outschool/gql-backend-generated";
import * as Time from "@outschool/time";

export type doesSectionHaveProperty<T> = (section: T) => boolean;

export type SectionOnlineClassroom = {
  details: Pick<Section["details"], "onlineClassroom">;
};

export function onlineClassroom(
  section: SectionOnlineClassroom,
): OnlineClassroom {
  if (section && section.details && section.details.onlineClassroom) {
    const type = section.details.onlineClassroom.type;
    const url = section.details.onlineClassroom.url;
    if (type === "zoom") {
      return section.details.onlineClassroom;
    } else if (!!url) {
      return section.details.onlineClassroom;
    }
  }
  return {
    type: "other",
    url: null,
  };
}

export type SectionUsesOutschoolVideoChat = Partial<
  Pick<Section, "usesOutschoolVideoChat">
> &
  SectionOnlineClassroom;

export const usesOutschoolVideoChat: doesSectionHaveProperty<
  SectionUsesOutschoolVideoChat
> = section => {
  if (!!section.usesOutschoolVideoChat) {
    // Client-side: use GraphQL schema field
    return true;
  }
  return false;
};

export type SectionSearchFilters = Pick<
  SearchFilters,
  | "dow"
  | "endBy"
  | "endByTime"
  | "startAfter"
  | "startAfterTime"
  | "startBefore"
  | "order"
>;

export function getMeetingsForDisplay<T extends { start_time: any }>(
  isOngoing: boolean,
  section: {
    meetings: Array<T>;
    allowsLateEnrollment: boolean;
  },
) {
  return isOngoing || section.allowsLateEnrollment
    ? section.meetings.filter(
        meeting => !Time.dayjs().isAfter(meeting.start_time),
      )
    : section.meetings;
}
